module.exports = __webpack_public_path__ + "img/image102.a101b0f8.png";